var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "文件名称" } },
            [
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "请输入需要查询的文件名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
              _c(
                "el-button",
                { staticClass: "query-btn", on: { click: _vm.fetchData } },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showUploadDialog },
                },
                [_vm._v("上传")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "calc(100vh - 200px)",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "文件名称",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatDateTime(scope.row.createTime)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "拆分状态", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.sliceStatus ? "已拆分" : "未拆分") +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "拆分数量", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.sliceCount) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "280",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.viewFile(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openSliceDialog(scope.row)
                          },
                        },
                      },
                      [_vm._v("切片")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.delItem(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传文件",
            visible: _vm.uploadDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "upload-dialog-content" }, [
            _c(
              "div",
              { staticClass: "upload-section" },
              [
                _c("span", { staticClass: "section-label" }, [
                  _vm._v("文件上传"),
                ]),
                _c(
                  "el-upload",
                  {
                    attrs: {
                      action: "#",
                      "auto-upload": false,
                      "on-remove": _vm.handleRemove,
                      "on-change": _vm.handleChange,
                      "file-list": _vm.fileList,
                      accept: "file",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [
                        _vm._v(
                          " 点击上传(支持markdown,条款pdf和excel三种格式) "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "content-section" }, [
              _c("span", { staticClass: "section-label" }, [
                _vm._v("知识内容"),
              ]),
              _c(
                "div",
                { staticClass: "content-list" },
                [
                  _vm.uploadContent[0]
                    ? _vm._l(_vm.uploadContent, function (text, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "content-item" },
                          [
                            _c("span", { staticClass: "item-index" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _c(
                              "div",
                              { staticClass: "item-content" },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.uploadLoading,
                                      expression: "uploadLoading",
                                    },
                                  ],
                                  attrs: {
                                    readonly: "",
                                    type: "textarea",
                                    value: text,
                                    rows: 3,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      })
                    : [
                        _c("el-input", {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.uploadLoading,
                              expression: "uploadLoading",
                            },
                          ],
                          attrs: {
                            readonly: "",
                            type: "textarea",
                            placeholder: "请选择文件进行转换",
                            rows: 5,
                          },
                        }),
                      ],
                ],
                2
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.uploadDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.fileList.length },
                  on: { click: _vm.confirmUpload },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.viewFileTitle,
            visible: _vm.viewDialogVisible,
            width: "800px",
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.viewDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.viewLoading,
                  expression: "viewLoading",
                },
              ],
              staticClass: "view-file-content",
            },
            [
              _vm.viewFileType === "pdf"
                ? _c("div", { staticClass: "pdf-viewer" }, [
                    _c(
                      "div",
                      { staticClass: "pdf-content" },
                      [
                        _c("pdf", {
                          attrs: { src: _vm.pdfFile, page: _vm.pdfCurrentPage },
                          on: {
                            "num-pages": function ($event) {
                              _vm.pdfTotalPages = $event
                            },
                            "page-loaded": function ($event) {
                              _vm.pdfCurrentPage = $event
                            },
                            error: _vm.handlePdfError,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pdf-controls" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: _vm.pdfCurrentPage <= 1 },
                            on: { click: _vm.prevPage },
                          },
                          [_vm._v("上一页")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.pdfCurrentPage) +
                              " / " +
                              _vm._s(_vm.pdfTotalPages)
                          ),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.pdfCurrentPage >= _vm.pdfTotalPages,
                            },
                            on: { click: _vm.nextPage },
                          },
                          [_vm._v("下一页")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm.viewFileType === "md"
                ? _c("div", { staticClass: "md-viewer" }, [
                    _c("pre", [_vm._v(_vm._s(_vm.viewFileContent))]),
                  ])
                : _vm.viewFileType === "excel"
                ? _c(
                    "div",
                    { staticClass: "excel-viewer" },
                    [
                      _c("vue-office-excel", {
                        attrs: { src: _vm.viewFileUrl },
                        on: {
                          rendered: _vm.handleExcelRendered,
                          error: _vm.handleExcelError,
                        },
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "file-viewer" }, [
                    _c("p", [
                      _vm._v("不支持预览此文件类型，请"),
                      _c(
                        "a",
                        { attrs: { href: _vm.viewFileUrl, target: "_blank" } },
                        [_vm._v("点击下载")]
                      ),
                      _vm._v("查看"),
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "download-link",
                        attrs: { href: _vm.viewFileUrl, target: "_blank" },
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("下载文件"),
                        ]),
                      ],
                      1
                    ),
                  ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.viewDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.sliceTitle,
            visible: _vm.sliceDialogVisible,
            width: "800px",
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sliceDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.sliceLoading,
                  expression: "sliceLoading",
                },
              ],
              staticClass: "slice-dialog-content",
            },
            [
              _vm.sliceList.length === 0
                ? _c("div", { staticClass: "empty-tip" }, [
                    _vm._v("暂无切片内容"),
                  ])
                : _c(
                    "div",
                    { staticClass: "slice-list" },
                    _vm._l(_vm.sliceList, function (item, index) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "slice-item" },
                        [
                          _c("span", { staticClass: "slice-index" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _c("el-input", {
                            staticClass: "slice-input",
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              placeholder: "请输入切片内容",
                            },
                            model: {
                              value: item.content,
                              callback: function ($$v) {
                                _vm.$set(item, "content", $$v)
                              },
                              expression: "item.content",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sliceDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveSlice } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }